// GaugeDashboard.tsx
import React, { useState, useRef, useEffect } from "react";
import VelocidadeVendasGauge from "../dashboardPages/charts/VelocidadeVendasGauge";
import VelocidadeGaugeDash from "./VelocidadeGaugeDash";
import "../../styles/dashboardPagesStyle/Charts.css";
import { Info } from "lucide-react";

interface GaugeDashboardProps {
  title: string;
  value: number;
  vendidos: number;
  restantes: number;
}

const GaugeDashboard: React.FC<GaugeDashboardProps> = ({ title, value, vendidos, restantes }) => {
  const [popup, setPopup] = useState<{ visible: boolean; text: string }>({
    visible: false,
    text: "",
  });

  const containerRefDash = useRef<HTMLDivElement>(null);
  const [scale, setScale] = useState(1);
  const [scale2, setScale2] = useState(1);
  const [scale3, setScale3] = useState(1);

  useEffect(() => {
    const updateScale = () => {
      if (containerRefDash.current) {
        const parentWidth = containerRefDash.current.offsetWidth;
        const parentHeight = containerRefDash.current.offsetHeight;

        const baseWidth = 180;   // largura original do gráfico
        const baseHeight = 180;  // altura original do gráfico (igual à largura se for círculo)

        // Scale considerando largura e altura, usa o menor para não cortar
        const scaleWidth = parentWidth / baseWidth;
        const scaleHeight = parentHeight / baseHeight;

        setScale3(scaleHeight);
        setScale2(scaleWidth);
        setScale(Math.min(scaleWidth, scaleHeight));
      }
    };

    updateScale();
    window.addEventListener("resize", updateScale);
    return () => window.removeEventListener("resize", updateScale);
  }, []);


  const handleInfoClick = () => {
    setPopup({
      visible: true,
      text: "Este gráfico mostra a velocidade de vendas (IVV), indicando unidades vendidas e restantes.",
    });
  };

  const fecharPopup = () => setPopup({ visible: false, text: "" });

  return (
    <div className="gauge-card-dashboard info-card">
      <div className="gauge-header">
        <div className="gauge-title-dashboard">{title}</div>
        <Info className="info-btn" size={20} onClick={handleInfoClick} />
      </div>

      {/* Container escalável */}
      <div ref={containerRefDash} style={{ display: 'flex', width: "100%", height: "100%", alignItems: 'center', justifyContent: 'center'}}>
        <div style={{ flex: 1, width: "100%", height: "100%", alignItems: 'center', justifyContent: 'center' }}>
          <VelocidadeGaugeDash value={value} vendidos={vendidos} restantes={restantes} />
        </div>
      </div>
      
      {/* Legenda */}
      <div className="oi">
        <div className="gauge-legend">
        <div className="legend-item-dashboard">
          <span>0-50 Ruim</span>
        </div>
        <div className="legend-item-dashboard">
          <span>50-80 Mediano</span>
        </div>
        <div className="legend-item-dashboard">
          <span>80-100 Ótimo</span>
        </div>
      </div>
      </div>
      

      {popup.visible && (
        <div className="info-popup-overlay" onClick={fecharPopup}>
          <div className="info-popup" onClick={(e) => e.stopPropagation()}>
            <h4>Informações</h4>
            <p>{popup.text}</p>
            <button onClick={fecharPopup}>Fechar</button>
          </div>
        </div>
      )}
    </div>
  );
};

export default GaugeDashboard;
